/**
 * Story `be-fe-verzekeraar-alleen-lezen-en-facturatie-verbergen` (22-10-2026, B-4 / AC 7) — de app Facturatie is
 * verborgen wanneer de hersteller van de gebruiker facturatie niet aan heeft staan (`UA_Repairer.InvoicingActive`).
 *
 * **De enige lezer van whoami `invoicingActive`** (scan `invoicingActive.test.ts`). Alleen `=== false` verbergt:
 * afwezig (System, geen hersteller, leesfout bij de backend), `null` of `true` ⇒ zichtbaar. Zo verbergt een
 * DB-hapering nooit een app die er hoort te staan.
 *
 * Welke app eronder valt staat declaratief in `apps.config.ts` (`hiddenWhenInvoicingInactive`, alleen op
 * `facturatie`; "Interne facturatie" valt er bewust niet onder). Het verbergen loopt via het bestaande
 * menu-mechanisme (`isAppHiddenByMenu` → app-wisselaar, tabs, route-guard, `appEntryRoute`) — geen tweede
 * routeclassificatie.
 *
 * Tonen ≠ mogen: er is (buiten scope) geen backend-afdwinging voor Facturatie bij InvoicingActive uit.
 *
 * Puur en `unknown`-tolerant; geen React-import.
 */
import type { App } from '@/config/apps.config';

/** Staat facturatie voor de hersteller van deze gebruiker expliciet uit? */
export function isInvoicingInactive(user: unknown): boolean {
    if (user === null || typeof user !== 'object') return false;
    return (user as { invoicingActive?: unknown }).invoicingActive === false;
}

/** Is deze app verborgen omdat facturatie uit staat? */
export function isAppHiddenByInvoicing(app: Pick<App, 'hiddenWhenInvoicingInactive'>, user: unknown): boolean {
    return app.hiddenWhenInvoicingInactive === true && isInvoicingInactive(user);
}
